var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon3 = function SvgIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 125,
    viewBox: "0 0 128 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 59,
    fill: "black",
    stroke: "#65C9DB",
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 63,
    r: 60,
    stroke: "#E38BB6",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9675 73.3557L72.3867 68.8509C74.3767 67.7921 78.2419 66.175 78.261 70.16L79.677 69.1782C83.6761 66.4253 86.6994 68.3697 85.2069 72.1814C92.3058 66.9836 94.8124 73.5675 91.6552 75.1846L75.9457 85.1567L69.2869 89.392C64.5798 92.3759 58.361 92.4337 56.6198 91.3749C46.6889 88.7952 43.8188 86.3503 35.1699 87.4669",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 69.659L41.2753 65.4623C43.8967 64.3842 46.8243 64.673 47.9341 65.4815C49.7902 66.8676 51.6462 68.2537 53.5023 69.6205C61.2326 75.3767 61.845 73.9328 70.953 74.4911C72.9622 74.6066 74.3016 77.8793 70.953 79.1692C62.4573 83.0772 57.2144 81.3253 49.484 77.3403",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9971 34.2949V37.8756",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9971 53.4697V57.0505",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9963 29C71.1427 29 78.5669 36.4695 78.5669 45.6716C78.5669 54.8736 71.1427 62.3431 61.9963 62.3431C52.85 62.3431 45.4258 54.8736 45.4258 45.6716C45.4258 36.4695 52.85 29 61.9963 29Z",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1644 39.743C65.5188 39.204 64.0455 38.6842 62.5721 38.5109C54.5738 37.6061 53.5597 45.7109 62.0555 45.6724C70.3216 45.6531 69.5371 53.7579 61.5388 52.8338C60.0655 52.6606 58.573 52.1408 56.9465 51.6018",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcon3;